import router from '@/router'
//import { sha256 } from 'js-sha256';
import api from '../../services/index.js'

export const actions = {
    async userSignIn({ commit }, payload) {
        try {
            commit('setLoading', true)
            await api.post("/login", {
                    username: payload.username,
                    password: payload.password,
                }, {
                    headers: {
                        "Content-Type": "application/json",
                    }
                }).then(async(v) => {
                    if (v.success) {
                        commit('setError', null)
                        commit('setAuth', true);
                        commit('setAccessToken', v.data.token)
                        await router.push('/home').catch(() => {});
                    } else {
                        commit('setAuth', false);
                        commit('setError', v.error.message)
                    }
                })
                .catch((e) => {
                    commit('setAuth', false);
                    commit('setError', e.error.message);
                });
        } catch (e) {
            commit('setError', e.message)
        } finally {
            commit('setLoading', false)
        }
    },
    async userSignUp({ commit }, payload) {
        try {
            commit('setLoading', true)
            await api.post("/auth-service/v2/signup", {
                    login_refer: payload.signupRefer,
                    knowus: payload.knowus,
                    sex: payload.sex,
                    age: payload.age,
                    signup_token: payload.signupToken,
                }).then((v) => {
                    if (v.status.code == 200) {
                        router.push('/login')
                    } else {
                        commit('setError', v.status.message)
                    }
                })
                .catch((e) => {
                    commit('setError', e.status.message);
                });
        } catch (error) {
            commit('setError', error.message)
        } finally {
            commit('setLoading', false)
        }
    },
    async userSignOut({ commit }) {
        commit('setAuth', false);
        commit('setAccessToken', null)
        commit('setUser', null)
        commit('setError', null)
        await router.push("/home").catch(() => {})
    },
    async checkAuth({ commit }) {
        try {
            commit('setLoading', true)
            const AccessToken = localStorage.getItem("AccessToken");
            if (AccessToken != null) {
                await api.get('/refresh').then((v) => {
                        if (v.success) {
                            commit('setUser', v.data[0]);
                        } else {
                            commit('setAuth', false);
                            commit('setError', null);
                            localStorage.setItem("AccessToken", null)
                                //router.push("login").catch(() => {})
                        }
                    })
                    .catch(() => {
                        commit('setAuth', false);
                        commit('setError', null);
                        localStorage.setItem("AccessToken", null)
                            //router.push("login").catch(() => {})
                    });
            } else {
                commit('setAuth', false);
                commit('setError', null);
                localStorage.setItem("AccessToken", null)
                router.push("login").catch(() => {})
            }
            return true;
        } catch (err) {
            commit('setError', null);
            localStorage.setItem("AccessToken", null)
                //await router.push("login").catch(() => {})
            return err.response.data
        } finally {
            commit('setLoading', false)
        }
    },
    setAccessToken({ commit }, payload) {
        commit('setAccessToken', payload)
    },
    setError({ commit }, payload) {
        commit('setError', payload)
    },
    setLoading({ commit }, payload) {
        commit('setLoading', payload)
    }
}